module.exports = __webpack_public_path__ + "img/3.27e50cd1.jpg";